import { render, staticRenderFns } from "./SavableRegion.vue?vue&type=template&id=61107d2c&scoped=true&"
import script from "./SavableRegion.vue?vue&type=script&lang=js&"
export * from "./SavableRegion.vue?vue&type=script&lang=js&"
import style0 from "./SavableRegion.vue?vue&type=style&index=0&id=61107d2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61107d2c",
  null
  
)

export default component.exports